import empanada from './Recursos/empananda.svg'
import casa from './Recursos/casa.svg'
import feliz from './Recursos/carafeliz.svg'
import ic_insta_color from './Recursos/ic_inst_color.svg'
import ic_face_color from './Recursos/ic_face_color.svg'
import inst from './Recursos/ic_insta.svg'
import face from './Recursos/ic_face.svg'
import tiktok from './Recursos/ic_tiktok.svg'
import lajas1 from './Recursos/lajas1.png'
import lajas2 from './Recursos/lajas2.png'
import lajas3 from './Recursos/lajas3.png'
import lajas4 from './Recursos/lajas4.png'
import carrera61 from './Recursos/carrera61.png'
import carrera62 from './Recursos/carrera62.png'
import carrera63 from './Recursos/carrera63.png'
import carrera64 from './Recursos/carrera64.png'
import once1 from './Recursos/once1.png'
import once2 from './Recursos/once2.png'
import once3 from './Recursos/once3.png'
import once4 from './Recursos/once4.png'
import once5 from './Recursos/once5.png'
import once6 from './Recursos/once6.png'
import puenes1 from './Recursos/puenes1.png'
import puenes2 from './Recursos/puenes2.png'
import puenes3 from './Recursos/puenes3.png'
import puenes4 from './Recursos/puenes4.png'
import tuquerres1 from './Recursos/tuquerres1.png'
import tuquerres2 from './Recursos/tuquerres2.png'
import aux from './Recursos/aux.png'
import yela from './Recursos/yela.png'
import ricardo from './Recursos/ricardo.png'
import roberto from './Recursos/roberto.png'

export const SECCIONES = ['Menu', 'Tiendas', 'Mayoristas', 'Nosotros']

export const NEGRITA = 'Bowlby One SC'

export const CATEGORIAS = ['UNO', 'DOS', 'TRES']

export const WASS = '3172880347'

export const INDICADORES = [
    {
        nombre: 'Años en el mercado',
        img: empanada,
        numero: 14
    },
    {
        nombre: 'Clientes Satisfechos',
        img: feliz,
        numero: 3500
    },
    {
        nombre: 'Locales Fisicos',
        img: casa,
        numero: 5
    },
]

export const DIRECCIONLOCALES = [
    {
        direccion: 'Cra 6 #10-54',
        nombre: 'Carrera 6',
        descripcion: 'Visítanos en la Calle 6, la vía más importante de la ciudad. ¡Fácil de encontrar, imposible de olvidar!',
        celular: '3158518951',
        lat: 0.8239815309607968,
        long: -77.63649087635666,
        fotos: [ carrera62, carrera63, carrera64],
        dias: 'Lunes a Sabado',
        horas: '8 Am a 8 Pm'
    },
    {
        direccion: 'Cra 11 #15-74',
        nombre: 'Carrera 11',
        descripcion: 'Nuestro local en la Calle 11 cuenta con espacio para estacionar, perfecto para disfrutar sin afanes. Ven en carro, quédate por el sabor.',
        celular: '3158518951',
        lat: 0.8242729310070137,
        long: -77.64239896517618,
        fotos: [once1, once2, once3, once4, once5, once6],
        dias: 'Lunes a Sabado',
        horas: '8 Am a 7 Pm'
    },
    {
        direccion: 'Cra 7 # 26-46',
        nombre: 'Puenes',
        descripcion: 'Estamos cerca del centro comercial más importante de la ciudad. Haz una pausa, ven por tu antojo y sigue disfrutando tu día.',
        celular: '3158142793',
        lat: 0.8284386112039551,
        long: -77.65280666866164,
        fotos: [puenes1, puenes2, puenes3, puenes4],
        dias: 'Domingo a Domingo',
        horas: 'L - S / 8am - 8pm',
        horasdos: 'D / 8am - 12am / 4pm a 8pm',
        size: 12
    },
    {
        direccion: 'Las Lajas - 30 mts del parqueadero',
        nombre: 'Las Lajas',
        descripcion: 'El sitio turístico más visitado de Ipiales. Disfruta lo mejor de Quesuditas antes o después de tu recorrido.',
        celular: '3172880347',
        lat: 0.8065385869104661,
        long: -77.58304459866552,
        fotos: [lajas1, lajas2, lajas3, lajas4],
        dias: 'Domingo a Domingo',
        horas: 'L-S / 7am - 12m / 3pm - 6pm',
        horasdos: 'D y Festivos / Jornada Continua',
        size: 12
    },
    {
        direccion: 'Calle 15 #14-44 Túquerres',
        nombre: 'Túquerres',
        descripcion: 'En esta tierra fría el verdadero calor está en lo que compartimos. Por eso preparamos nuestros platos con mucho amor para regalar calorcito al alma, convirtiendo cada bocado en un momento para disfrutar.',
        celular: '3152038243',
        lat: 1.08897,
        long: -77.61915,
        fotos: [tuquerres1, tuquerres2],
        dias: 'Domingo a Domingo',
        horas: 'L-V / 8:30am - 7pm Jornada Continua',
        horasdos: 'S Y D / 9am a 12:30pm y 2:30pm a 7pm',
        size: 12
    },
]

export const REDES = [
    {
        nombre: 'tiktok',
        imgColor: tiktok,
        img: tiktok,
        url: 'https://www.tiktok.com/@quesuditascafeteria'
    },
    {
        nombre: 'facebook',
        imgColor: ic_face_color,
        img: face,
        url: 'https://www.facebook.com/Quesuditas.Cafeteria'
    },
    {
        nombre: 'instagram',
        imgColor: ic_insta_color,
        img: inst,
        url: 'https://www.instagram.com/quesuditas.cafeteria/?hl=es'
    },
]

export const CONTACTOS = [
    {
        nombre: 'Celular',
        descripcion: '+57 317 288 0347'
    }, {
        nombre: 'Correo',
        descripcion: 'info@quesuditas.com'
    }

]

export const TESTIMONIOS = [

    {
        nombre: 'Roberto N. Nieto',
        descripcion: 'Buena comida, excelente atención por parte del personal y una variedad de alimentos, la gran mayoría son de comida rápida. Se puede pagar con Tarjeta de débito y crédito',
        foto: roberto,
    },
    {
        nombre: 'Miguel Alfonzo Yela',
        descripcion: 'Su atención. Servicio y el aseo que se mira tanto en el personal como el lugar su preparación en las empanadas de pollo y queso son sabrosas y lo más importante su bienvenida al atender a personas de tercera edad exitos',
        foto: yela
    },
    {
        nombre: 'Ricardo Fuel',
        descripcion: 'Me gusto mucho ir a Quesuditas muy buena atención el sabor de las empanadas es exquisito, sirven un buen café, los desayunos son deliciosos, es un lugar muy agradable para conversar con amigos, se la pasa chevere',
        foto: ricardo
    },
    {
        nombre: 'Angelita Aux',
        descripcion: 'Las mejores empanadas del mundo, su atención es insuperable! Amo repetir este lugar!',
        foto: aux
    },
]

export const LINKMENU = 'https://quesuditas.com/menus/menu.pdf'